import {ADD_OUTSTANDING_ITEM, REMOVE_OUTSTANDING_ITEM} from "./actionTypes"

export const addOutstandingItem = (item) => ({
  type: ADD_OUTSTANDING_ITEM,
  item
})

export const removeOutstandingItem = (id) => ({
  type: REMOVE_OUTSTANDING_ITEM,
  id
})